import { SET_LAUNCHER_TEXT, SET_VERSION_TEXT, SET_PATCH_NOTES, SET_TEXTS } from './constants'

const initialState = {
    launcher: '',
    version: '',
    patchNotes: '',
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_LAUNCHER_TEXT: {
            return {
                ...state,
                launcher: action.payload,
            }
        }

        case SET_VERSION_TEXT: {
            return {
                ...state,
                version: action.payload,
            }
        }

        case SET_PATCH_NOTES: {
            return {
                ...state,
                patchNotes: action.payload,
            }
        }

        case SET_TEXTS: {
            return action.payload
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/LoadingBar/data/texts/reducer.js